<template>
    <div class="container pt-5 pb-5 page">
        <h1 class="mb-5">Veelgestelde vragen</h1>
        <VueFaqAccordion activeColor="#0080ff" fontColor="#001e3b" :items="questions" />
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
export default {
  components: {
    VueFaqAccordion
  },
  data () {
    return {
      questions: [
          {
            title: 'Wat is Azurity?',
            value: 'Azurity is een beveiligingsbedrijf, erkend door het Ministerie van Justitie op nummer ND 5590, met een innovatief platform. Het platform is een veilige omgeving waar vraag, aanbod, service, informatie & betaling samen komen. Opdrachtgevers en veiligheidsprofessionals kunnen via dit platform elkaar veilig contracteren voor een opdracht.',
            category: 'Algemeen'            
          },
          {
            title: 'Wat is het vergunningsnummer?',
            value: 'ND 5590',
            category: 'Algemeen'            
          },
          {
            title: 'Onze missie',
            value: 'Wij geloven in de zelfsturendheid van de bij ons aangesloten beveiligers. Door het creeren van flexibiliteit en zelfstandigheid geloven wij dat het ten goede komt van de kwaliteit en werk/privé balans. En dus meer werkplezier. En dat willen wij faciliteren, of je nu zzp-er, bij een andere werkgever of bij ons in dienst bent. Wij maken geen onderscheid.',
            category: 'Algemeen'
          },
          {
            title: 'Welke diensten kan ik via Azurity afnemen?',
            value: '<ul><li><a href="/security/information/beveiliging/objectbeveiliging">Objectbeveiligers</a></li><li><a href="/security/information/beveiliging/evenementenbeveiliging">Evenementenbeveiligers</a></li><li>Horecaportiers</li><li><a href="/security/information/beveiliging/winkelsurveillance">Winkelsurveillanten</a></li><li>Receptionisten</li><li>Chauffeurs</li><li><a href="/security/information/beveiliging/persoonsbeveiliging">Persoonsbeveiligers</a></li><li><a href="/security/information/verkeersregelaars">Verkeersregelaars</a></li><li>Brandwachten</li><li><a href="/security/information/ehbo">EHBO-ers</a></li><li><a href="/security/information/beveiliging/zorgbeveiliging">Zorgbeveiligers</a></li><li><a href="/security/information/beveiliging/hotelbeveiliging">Hotelbeveiligers</a></li><li><a href="/security/information/beveiliging/museumbeveiliging">Museumbeveiligers</a></li></ul>',
            category: 'Algemeen'
          },
          {
            title: 'Hoe gaat de betaling?',
            value: 'Azurity zorgt voor de betalingsafhandeling tussen opdrachtgever en beveiliger. De opdrachtgever betaald voor de opdracht, de beveiliger krijgt binnen 48 uur uitbetaald zodra de opdracht is voltooid.',
            category: 'Algemeen'
          },
          {
            title: 'Hoe werkt het verwijsprogramma?',
            value: 'Nadat u heeft geregistreerd, ontvangt u een unieke link waarmee anderen zich kunnen registeren. U verdient dan per registratie die u aanbrengt. <a href="/security/referral" target="_blank">Lees meer...</a>',
            category: 'Algemeen'
          },
          {
            title: 'Hoe werkt het platform?',
            value: 'Je maakt een profiel aan as opdrachtgever. Middels onze slimme zoek-tool, zoek en contracteer de juiste veiligheidsprofessionals. Maak een planning en zie gelijk de offerte op je scherm. <a href="/security/information/opdrachtgever">Lees meer...</a>',
            category: 'Opdrachtgevers'
          },
          {
            title: 'Zijn de professionals van Azurity gecertificeerd?',
            value: 'Ja. Elke professional wordt uitvoerig gescreended op de juiste certificeringen. Wij vinden dat het belangrijk is om de kwaliteit en kennis niveau van de bij ons aangesloten professionals te borgen.',
            category: 'Opdrachtgevers'
          },
          {
            title: 'Wat kost het inhuren van een beveiliger?',
            value: 'Dat hangt af van de vraag en aanbod en de tarieven waarvoor de beveiligers bereid zijn te werken. Een beveiliger kan nooit onder CAO niveau zijn tarief aanbieden. Je bepaalt zelf wie je wanneer tegen welk tarief inhuurt.',
            category: 'Opdrachtgevers'
          },
          {
            title: 'Wat als ik niet tevreden ben met de professional?',
            value: 'Wanneer u ontevreden bent over de uitgevoerde opdracht, meldt dit ons binnen 24 uur. Wij zullen contact opnemen met de professional en samen zoeken voor een oplossing. Wanneer we er niet uitkomen of blijkt dat er een aantoonbare wanprestatie is geleverd, krijgt u uw geld terug.',
            category: 'Opdrachtgevers'
          },
          {
            title: 'Kan ik als particulier ook gebruik maken van Azurity?',
            value: 'Jazeker, Azurity is voor zowel zakelijke als particuliere opdrachtgevers. Voor als u bijvoorbeeld uw huis wilt laten beveiligen tijdens uw vakantie of in het trieste geval van een begrafenis.',
            category: 'Opdrachtgevers'
          },
          {
            title: 'Kan ik alleen als beveiliger werken?',
            value: 'Nee, je kunt je met de juiste papieren ook aanmelden als <a href="/security/information/verkeersregelaars">verkeersregelaar</a>, brandwachten en/of <a href="/security/information/ehbo">EHBO-er</a>.',
            category: 'Professionals'
          },
          {
            title: 'Kan ik mijn eigen agenda bepalen?',
            value: 'Ja, middels de kalender module kun je precies aangeven welke dagen je wel en niet wilt werken.',
            category: 'Professionals'
          },
          {
            title: 'Kan ik mijn eigen tarief per dag bepalen?',
            value: 'Ja, je stelt eerst een basis dag/avond/nacht/weekend tarief in. Vervolgens kun je via onze kalender module per dag nog een ander tarief instellen.',
            category: 'Professionals'
          },
          {
            title: 'Kan ik als freelancer/zelfstandige via Azurity werken?',
            value: 'Ja.',
            category: 'Professionals'
          },
          {
            title: 'Kan ik in loondienst voor Azurity werken?',
            value: 'Je kan bij Azurity een afroepcontract krijgen. Neem <a href="/security/contact">contact</a> op voor meer informatie.',
            category: 'Professionals'
          },
          {
            title: 'Ik ben in dienst bij een ander beveiliginsbedrijf. Kan ik ook voor Azurity werken?',
            value: 'Jazeker. Je kan je aanmelden via jouw werkgever, maar ook als zelfstandige freelancer of met een afroepcontract bij Azurity. Uiteraard moet jou werkgever hier wel mee akkoord zijn.',
            category: 'Professionals'
          },
          {
            title: 'Wat ga ik verdienen?',
            value: 'Dat bepaal je zelf. Je kunt je eigen tarief instellen. Dat kan zelfs per dag! <a href="/security/information/professional">Lees meer...</a>',
            category: 'Professionals'
          }
        ]
    }
  }
}
</script>

<style scoped>
section.faq {
  padding: 0;
}
</style>

